import React from 'react';
import { ClipPlayer } from './ClipPlayer';
import { CheckCircle2 } from 'lucide-react';

const VERSION = '20261027d';

export const ShowcaseSection = ({ section, index, refId }) => (
  <section className="sc-slide" id={`sc-${section.id}`} data-testid={`showcase-section-${section.id}`}>
    <div className="sc-text">
      <div className="sc-num">{String(index + 1).padStart(2, '0')}</div>
      <h2 className="sc-title" data-testid={`showcase-title-${section.id}`}>{section.title}</h2>
      <p className="sc-value">{section.value}</p>
      <ul className="sc-features">
        {section.features.map((f) => (
          <li key={f}><CheckCircle2 size={16} aria-hidden="true" /><span>{f}</span></li>
        ))}
      </ul>
      {refId && <ClipPlayer refId={refId} />}
    </div>
    <div className={`sc-shots ${section.shots.length > 1 ? 'sc-shots-2' : ''}`}>
      {section.shots.map((s) => (
        <figure key={s} className="sc-shot">
          <img src={`/showcase/${s}.png?v=${VERSION}`} alt={`${section.title} screen`}
               data-testid={`showcase-img-${s}`} />
        </figure>
      ))}
    </div>
  </section>
);
